<!--  -->
<template>
    <div class='box box_f1 box_between'>
        <div class="wrapper box_f1 box box_v">
            <div class="title">各区域社保申请统计</div>

            <div :class="['items',index==0?'x':'']" v-for="(item,index) in [1,2,3,4,5,6,7,8]" :key="index">
                <i class="iconfont icon-dingweiweizhi xx"></i>
                <div class="boxs_xx">
                    <span class="area">x襄阳经济界x区</span>
                    <span class="bar"></span>
                    <span class="count">2222 <span class="sf">人</span> </span>
                </div>

            </div>

        </div>
        <div class="wrapper box_f1 box box_v">
            <div class="title">各区域高龄津贴申请统计</div>

                <div :class="['items',index==0?'x':'']" v-for="(item,index) in [1,2,3,4,5,6,7,8]" :key="index">
                    <i class="iconfont icon-dingweiweizhi xx"></i>
                    <div class="boxs_xx">
                        <span class="area">x襄阳经济界x区</span>
                        <span class="bar"></span>
                        <span class="count">2222 <span class="sf">人</span> </span>
                    </div>
                    
                </div>

        </div>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list1:[],
            list2:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getBankData(){
            this.$get(this.urlobj.estateTop5,{
                type:'bank'
            }).then(res=>{
                let maxNum = res.rows[0].handleCount
                this.list1 = res.rows.splice(0,5).map(item=>{
                    return {
                        name:item.name,
                        handleCount:item.handleCount.toLocaleString(),
                        width:(item.handleCount/maxNum).toFixed(2)*100 + '%'
                    }
                })
            })
        },
        getDevelopData(){
            this.$get(this.urlobj.estateTop5,{
                type:'develop'
            }).then(res=>{
                let maxNum = res.rows[0].handleCount
                this.list2 = res.rows.splice(0,5).map(item=>{
                    return {
                        name:item.name,
                        handleCount:item.handleCount.toLocaleString(),
                        width:(item.handleCount/maxNum).toFixed(2)*100 + '%'
                    }
                })
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        // this.getBankData()
        // this.getDevelopData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
    padding:20px 20px 6px 20px;
    margin-top: 5px;
}
.wrapper:first-child{
    margin-right:10px;
}
.wrapper:last-child{
    margin-left:10px
}
.title{
    height: 18px;
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:10px 0 0 20px
}

.x{
    margin-top:19px
}
.items{
    height: 34px;
    line-height: 34px;
    width: 100%;
    border: 1px solid #0659a8;
    align-items: center;

    margin-bottom: 9px;
    
    
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #B3DDFF;
    position: relative;
    
    .iconfont{
        margin:  0 0  0 13px;
        
        font-size: 18px; 
        // background: linear-gradient(0deg, #00F6FF, #0290FE);
    }
    .xx {
        font-weight: 700;
        background-image: -webkit-linear-gradient(left bottom, #00F6FF, #0290FE);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

    }
    .boxs_xx{
        display: flex;
        justify-content: space-between;
        align-items: center;
        // width: 90%;
        position: absolute;
        right: 41px;
        top: -1px;
        left: 41px;
    }
    .bar{
        display: inline-block;
        width: 201px;
        height: 9px;
        background: linear-gradient(90deg, #029EFE 0%, rgba(1, 125, 255, 0.2) 100%);
        border-radius: 5px;
        
    }


    .count {
        z-index: 90;
        position: absolute;
        line-height: 18px;
        right: -20px;
        top: 8px;
        width: 64px;
        height: 18px;
        font-size: 18px;
        font-family: FZLanTingHei-B-GBK;
        font-weight: 400;
        font-style: italic;
        color: #B3DDFF;
        background: linear-gradient(0deg, #00A8FF 10.205078125%, #4CECFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        .sf{
            font-size: 14px;
            font-family: FZLanTingHei-B-GBK;
            font-weight: 400;
            color: #B3DDFF;
        }
    }

}
</style>